'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _compose = require('./compose');

var _compose2 = _interopRequireDefault(_compose);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var item = args.pop();
    return _compose2.default.apply(undefined, args)(item);
};


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/util/composeWith.js
// module id = 273
// module chunks = 35783957827783